/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerFindAllProcessingQueryResponse, DocumentsControllerFindAllProcessingPathParams, DocumentsControllerFindAllProcessingQueryParams, DocumentsControllerFindAllProcessing401, DocumentsControllerFindAllProcessing403 } from "../../models/documentsController/DocumentsControllerFindAllProcessing";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentsControllerFindAllProcessing } from "../../clients/documentsService/documentsControllerFindAllProcessing";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentsControllerFindAllProcessingQueryKey = (id: DocumentsControllerFindAllProcessingPathParams["id"], params: DocumentsControllerFindAllProcessingQueryParams) => [{
  url: '/api/v1/documents/:id/processing',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type DocumentsControllerFindAllProcessingQueryKey = ReturnType<typeof documentsControllerFindAllProcessingQueryKey>;
export function documentsControllerFindAllProcessingQueryOptions(id: DocumentsControllerFindAllProcessingPathParams["id"], params: DocumentsControllerFindAllProcessingQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentsControllerFindAllProcessingQueryKey(id, params);
  return queryOptions<DocumentsControllerFindAllProcessingQueryResponse, ResponseErrorConfig<DocumentsControllerFindAllProcessing401 | DocumentsControllerFindAllProcessing403>, DocumentsControllerFindAllProcessingQueryResponse, typeof queryKey>({
    enabled: !!(id && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentsControllerFindAllProcessing(id, params, config);
    }
  });
}

/**
 * @summary Get all processing jobs for a document
 * {@link /api/v1/documents/:id/processing}
 */
export function useDocumentsControllerFindAllProcessing<TData = DocumentsControllerFindAllProcessingQueryResponse, TQueryData = DocumentsControllerFindAllProcessingQueryResponse, TQueryKey extends QueryKey = DocumentsControllerFindAllProcessingQueryKey>(id: DocumentsControllerFindAllProcessingPathParams["id"], params: DocumentsControllerFindAllProcessingQueryParams, options: {
  query?: Partial<QueryObserverOptions<DocumentsControllerFindAllProcessingQueryResponse, ResponseErrorConfig<DocumentsControllerFindAllProcessing401 | DocumentsControllerFindAllProcessing403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentsControllerFindAllProcessingQueryKey(id, params);
  const query = useQuery({
    ...documentsControllerFindAllProcessingQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentsControllerFindAllProcessing401 | DocumentsControllerFindAllProcessing403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}